/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Cli_DescInputs */



/**
* | output |
* | --- |
* | "Configure command-line tools for enhanced workflows" |
*
* @param {Options_Cli_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_desc = /** @type {((inputs?: Options_Cli_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Configurer des outils en ligne de commande pour des flux de travail améliorés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Konfigurieren Sie Befehlszeilentools für optimierte Arbeitsabläufe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Configurare gli strumenti della riga di comando per flussi di lavoro migliorati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройка инструментов командной строки для повышения эффективности рабочих процессов.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configurar herramientas de línea de comandos para flujos de trabajo mejorados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("配置命令行工具以增强工作流程")
	if (locale === "ja") return /** @type {LocalizedString} */ ("強化されたワークフローのためのコマンドラインツールを構成する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बेहतर वर्कफ़्लो के लिए कमांड-लाइन टूल कॉन्फ़िगर करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configure ferramentas de linha de comando para fluxos de trabalho aprimorados.")
	return /** @type {LocalizedString} */ ("Configure command-line tools for enhanced workflows")
});